// extracted by mini-css-extract-plugin
export default {"pdf-viewer":"PdfViewer_pdf-viewer__ZjUNr"};